import { Public } from 'shared/Public';
import React from 'react';
import { Redirect } from 'react-router-dom';
import AboutUs from '../parent-portal/public/MarketingSite/AboutUs';
import HowItWorks from '../parent-portal/public/MarketingSite/HowItWorks';
import { Substitutes } from '../parent-portal/public/MarketingSite/substitutes';
import { Workers } from '../parent-portal/public/MarketingSite/workers';
import Home from '../parent-portal/public/MarketingSite/home';

export default function MarketingSiteRoutes() {
    return (
        <>
            <Public exact path="/how-it-works" component={HowItWorks} />
            <Public exact path="/substitutes" component={Substitutes} />
            <Public exact path="/about-us" component={AboutUs} />
            <Public exact path="/workers" component={Workers} />

            {/* NOTE: Order matters!!!!! */}
            {localStorage.getItem('token') === null ? (
                <Public exact path="/" component={Home} />
            ) : (
                <Public exact path="/" component={<></>}>
                    <Redirect to="/home" />
                </Public>
            )}
        </>
    );
}
